import { useEffect, useRef, useState } from "react";
import { createChart } from "lightweight-charts";
import { fmt } from "../lib/api";
import { useFetch } from "../lib/useFetch";
import { Panel, Spinner } from "./common";

const rm = (v) => `${v < 0 ? "-" : ""}RM${fmt(Math.abs(v || 0), 2)}`;
const tone = (v) => (v > 0 ? "text-emerald-600" : v < 0 ? "text-red-600" : "text-slate-500");

function PnlChart({ rows, id }) {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current || !rows.length) return undefined;
    const c = createChart(el.current, { height: 220, layout: { background: { color: "#fff" }, textColor: "#475569", fontSize: 10 },
      grid: { vertLines: { color: "#F1F5F9" }, horzLines: { color: "#F1F5F9" } }, rightPriceScale: { borderColor: "#E2E8F0" },
      timeScale: { borderColor: "#E2E8F0" }, autoSize: true });
    const bars = c.addHistogramSeries({ priceLineVisible: false, lastValueVisible: false });
    bars.setData(rows.map((r) => ({ time: r.day, value: r.pnl, color: r.pnl >= 0 ? "rgba(16,185,129,0.7)" : "rgba(239,68,68,0.7)" })));
    const line = c.addLineSeries({ color: "#2563EB", lineWidth: 2, priceLineVisible: false });
    line.setData(rows.map((r) => ({ time: r.day, value: r.cum })));
    c.timeScale().fitContent();
    return () => c.remove();
  }, [rows]);
  if (!rows.length) return <p className="py-8 text-center text-xs text-slate-500" data-testid={`perf-empty-${id}`}>No LIVE results yet.</p>;
  return <div ref={el} className="w-full" data-testid={`perf-chart-${id}`} />;
}

export const LivePerformance = () => {
  const { data } = useFetch("/live/performance", 300000);
  const [tab, setTab] = useState("dmi");
  const tabs = [["dmi", "DMI trades"], ["account", "Whole Moomoo account"]];
  const d = data?.[tab];
  return (
    <Panel title="LIVE performance · after fees" className="mb-3" testid="live-performance"
      right={<div className="flex gap-1">{tabs.map(([k, l]) => (
        <button key={k} type="button" onClick={() => setTab(k)} data-testid={`perf-tab-${k}`}
          className={`rounded-sm border px-2 py-1 text-[11px] transition-colors ${tab === k ? "border-blue-600 bg-blue-600 text-white" : "border-[#E2E8F0] bg-white text-slate-600 hover:border-blue-500"}`}>{l}</button>))}</div>}>
      {!data ? <Spinner /> : (
        <>
          <div className="mb-2 flex flex-wrap gap-x-6 gap-y-1 text-xs">
            <span>Total <b className={`mono ${tone(d.total)}`} data-testid="perf-total">{rm(d.total)}</b></span>
            {tab === "dmi" ? <>
              <span>Fees paid <b className="mono">{rm(d.fees)}</b></span>
              <span>Closed trades <b className="mono" data-testid="perf-closed">{d.closed_trades}</b></span>
              <span>Win rate <b className="mono">{d.win_rate == null ? "—" : `${d.win_rate}%`}</b></span>
            </> : <span>Since <b className="mono">{d.since || "—"}</b></span>}
          </div>
          <PnlChart rows={d.rows} id={tab} />
          <p className="mt-2 text-[10px] text-slate-500">Bars = profit/loss each day, blue line = running total. {data.note}</p>
        </>
      )}
    </Panel>
  );
};
